export default {
  layout: {
    landing: 'LandingLayout',
    app: 'AppLayout',
    stacked: 'StackedLayout',
    listingDetail: 'ListingDetailLayout'
  }
};
